import {pageInfo, initEdit, addData, editData, deleteData, exportData, importData, downLoadTemplate} from './../api';
import { Message } from 'element-ui';
import {companyListData} from "../../company/api";
import {listCarrier} from "../../../../api";
const carrier = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    addDataObj: null,
    editDataObj: null,
    deleteDataObj: null,
    initPageObj: null,
    initEditObj: null,
    exportDataObj: null,
    importDataObj: null,
    downLoadTemplateObj: null,
    companyObj: null,
    carrierObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state, data) {
      state.initPageObj = data.obj || {};
    },
    INIT_EDIT(state, data) {
      state.initEditObj = data.obj;
    },
    ADD_DATA(state, data) {
      state.addDataObj = data;
    },
    EDIT_DATA(state, data) {
      state.editDataObj = data;
    },
    DELETE_DATA(state, data) {
      state.deleteDataObj = data;
    },
    EXPORT_DATA(state, data) {
      state.exportDataObj = data;
    },
    IMPORT_DATA(state,data){
      state.importDataObj = data;
    },
    LIST_COMPANY(state,data){
      state.companyObj = data.obj;;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.downLoadTemplateObj = data;
    },
    LIST_CARRIER(state, data) {
      state.carrierObj = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({ commit }, obj) {
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //初始化更新对象事件
    async initEdit({ commit }, obj) {
      let resp = await initEdit(obj);
      commit('INIT_EDIT', resp);
    },
    //新增保存事件
    async addData({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    //修改保存事件
    async editData({ commit }, obj) {
      let resp = await editData(obj);
      commit('EDIT_DATA', resp);
    },
    //删除数据事件
    async deleteData({ commit }, obj) {
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    //导出文件
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //导入
    async importData({commit}, obj){
      let resp = await importData(obj);
      commit('IMPORT_DATA', resp);
    },
    //模板下载
    async downLoadTemplate({ commit }, obj) {
      let resp = await downLoadTemplate(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    //机构
    async listCompany({ commit }, obj) {
      let resp = await companyListData(obj);
      commit('LIST_COMPANY', resp);
    },
    //承运商
    async listCarrier({ commit }, obj) {
      let resp = await listCarrier(obj);
      commit('LIST_CARRIER', resp);
    },
  }
}
export default carrier



// WEBPACK FOOTER //
// ./src/page/mdm/carrier/store/carrier.store.js